import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPSD2Verified = loadable(() => import('./PSD2Verified'), {
  fallback: <Loader />,
});
